// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fundAllomentContainer {
    .budgetElement {
        width: 82%;
        box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274);
        border-radius: 5px;
        padding: 20px 50px;
        background-color: white;

        label {
            font-size: 16px;
            font-weight: 500;
        }


        .elements {
            margin: 15px 0px;
        }


        textarea,
        select,
        input {
            width: 100%;
            border: 1px solid #505050;
            padding: 5px 10px;
            font-size: 16px;
            font-weight: 400;
            border-radius: 3px;
        }

        select {
            font-size: 14px !important;
            font-weight: 500 !important;
            color: #817f7f;
        }

        select:focus {
            color: black;
        }

        textarea {
            height: 12vh;
        }

        ::placeholder {
            color: #817f7f;
        }
    }

    .tableContainer {
        width: 100%;

        table {
            width: 100%;
            border: 1px solid #0094DE;


            tr,
            th,
            td {
                padding: 10px;
                font-size: 14px;
            }

            th,
            td {
                border: 1px solid #000000;
                font-size: 14px;

            }

            thead {
                tr {
                    background-color: #0094DE;
                    color: white;

                    th {
                        font-weight: 500 !important;
                    }
                }
            }

            tbody {
                tr {
                    border: 1px solid #000000 !important;
                    td {
                        border: 1px solid #000000 !important;
                        font-weight: 500 !important;
                    }

                }
            }

        }
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/Master/SchemeManagement/Fundallotment.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;QACV,gDAAgD;QAChD,kBAAkB;QAClB,kBAAkB;QAClB,uBAAuB;;QAEvB;YACI,eAAe;YACf,gBAAgB;QACpB;;;QAGA;YACI,gBAAgB;QACpB;;;QAGA;;;YAGI,WAAW;YACX,yBAAyB;YACzB,iBAAiB;YACjB,eAAe;YACf,gBAAgB;YAChB,kBAAkB;QACtB;;QAEA;YACI,0BAA0B;YAC1B,2BAA2B;YAC3B,cAAc;QAClB;;QAEA;YACI,YAAY;QAChB;;QAEA;YACI,YAAY;QAChB;;QAEA;YACI,cAAc;QAClB;IACJ;;IAEA;QACI,WAAW;;QAEX;YACI,WAAW;YACX,yBAAyB;;;YAGzB;;;gBAGI,aAAa;gBACb,eAAe;YACnB;;YAEA;;gBAEI,yBAAyB;gBACzB,eAAe;;YAEnB;;YAEA;gBACI;oBACI,yBAAyB;oBACzB,YAAY;;oBAEZ;wBACI,2BAA2B;oBAC/B;gBACJ;YACJ;;YAEA;gBACI;oBACI,oCAAoC;oBACpC;wBACI,oCAAoC;wBACpC,2BAA2B;oBAC/B;;gBAEJ;YACJ;;QAEJ;IACJ;AACJ","sourcesContent":[".fundAllomentContainer {\n    .budgetElement {\n        width: 82%;\n        box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274);\n        border-radius: 5px;\n        padding: 20px 50px;\n        background-color: white;\n\n        label {\n            font-size: 16px;\n            font-weight: 500;\n        }\n\n\n        .elements {\n            margin: 15px 0px;\n        }\n\n\n        textarea,\n        select,\n        input {\n            width: 100%;\n            border: 1px solid #505050;\n            padding: 5px 10px;\n            font-size: 16px;\n            font-weight: 400;\n            border-radius: 3px;\n        }\n\n        select {\n            font-size: 14px !important;\n            font-weight: 500 !important;\n            color: #817f7f;\n        }\n\n        select:focus {\n            color: black;\n        }\n\n        textarea {\n            height: 12vh;\n        }\n\n        ::placeholder {\n            color: #817f7f;\n        }\n    }\n\n    .tableContainer {\n        width: 100%;\n\n        table {\n            width: 100%;\n            border: 1px solid #0094DE;\n\n\n            tr,\n            th,\n            td {\n                padding: 10px;\n                font-size: 14px;\n            }\n\n            th,\n            td {\n                border: 1px solid #000000;\n                font-size: 14px;\n\n            }\n\n            thead {\n                tr {\n                    background-color: #0094DE;\n                    color: white;\n\n                    th {\n                        font-weight: 500 !important;\n                    }\n                }\n            }\n\n            tbody {\n                tr {\n                    border: 1px solid #000000 !important;\n                    td {\n                        border: 1px solid #000000 !important;\n                        font-weight: 500 !important;\n                    }\n\n                }\n            }\n\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
